// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueTouch from 'vue-touch';
import Trend from 'vuetrend';
import Toasted from 'vue-toasted';
import VueApexCharts from 'vue-apexcharts';
import VueCompositionAPI from '@vue/composition-api'
import OtpInput from "@bachdgvn/vue-otp-input";
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueEllipseProgress from 'vue-ellipse-progress'

import store from './store';
import router from './router';
import App from './App';
import layoutMixin from './mixins/layout';
import echo from './plugins/echo';

Vue.use(BootstrapVue);
Vue.use(VueTouch);
Vue.use(Trend);
Vue.component('apexchart', VueApexCharts);
Vue.mixin(layoutMixin);
Vue.use(Toasted, {duration: 10000});
Vue.use(VueCompositionAPI);
Vue.component("v-otp-input", OtpInput);
Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueEllipseProgress)

//@make echo available globally
Vue.prototype.$echo = echo;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.ecpToken) {
    if (localStorage.getItem('ecpToken')) {
      next();
    } else {
      next({name: 'PasswordlessLogin'});
    }
  } else {
    if (to.meta.roles === '*') {
      next();
    } else {
      if (!localStorage.getItem('user.role')) {
        next({name: 'PasswordlessLogin'});
      } else {
        let roles = to.meta.roles.split('|');
        if (roles.includes(localStorage.getItem('user.role'))) {
          next();
        } else if (localStorage.getItem('user.role') === 'COLLABORATOR' && !roles.includes(localStorage.getItem('user.role'))) {
          next({name: 'Installation'});
        } else {
          next({name: 'PasswordlessLogin'});
        }
      }
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});
